import React from 'react'
import './style.css'
import Button from '../CtaButton'
import { Link } from 'react-router-dom'

const CaseStudyCard = ({ data }) => {
  return (
    <>
      <Link to={`/case-studies/${data?.slug}`} style={{ textDecoration: 'none' }}>
        <div className="case-study-main-card">
          <div className="case-study-header">
            <div className="kfc-logo">{data?.mainHeading}</div>
            <div className="case-study-page-card-button">
              <i className="fa-solid fa-arrow-right-long"></i>
            </div>
          </div>
          <p className="case-study-description">
            {data?.mainDescription?.split(" ").length > 20
              ? data?.mainDescription?.split(" ").slice(0, 20).join(" ") + "....."
              : data?.mainDescription}
          </p>
          <div className="case-study-stats">
            {data?.mainStats?.map((list, index) => {
              return <div className="stat-item" key={index}>
                <div className="stat-value">{list?.value}</div>
                <div className="stat-label">{list?.text}</div>
              </div>
            })}
          </div>
          <div className="case-study-image-container">
            <img src={`${data?.mainImage}`} alt="Case Study Image" />
          </div>
        </div>
      </Link>
    </>
  )
}

export default CaseStudyCard